import { useContext, useState } from "react";

import FnrIcon from "UI/FnrIcon";
import { MoreButton, MoreButtonText } from "./MoreButton";
import FnrLoadingBricks from "UI/FnrLoadingBricks2";

import { SignupsAppState } from "Signups/state.js";
import API from "Signups/API";

export default function ArchiveSignup() {
  const [
    {
      currentSignupList: { ID: signupListID, signupListStatusID },
    },
    dispatch,
  ] = useContext(SignupsAppState);

  const isArchived = signupListStatusID * 1 === 4;

  const [isLoading, setIsLoading] = useState(false);

  const archiveSignup = () => {
    setIsLoading(true);
    changeSignupStatus(4);
  };

  const activateSignup = () => {
    setIsLoading(true);
    changeSignupStatus(1);
  };

  const changeSignupStatus = (status) => {
    API.changeSignupStatus(signupListID, status)
      .post()
      .then((resp) => {
        if (resp.success) {
          dispatch({
            type: "Change Status",
            status: resp.signupListStatusID,
            ID: signupListID,
          });
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);

        alert(
          err.message ||
            "Oh no! A problem occurred. Please refresh and try again, or contact help@flocknote.com."
        );
      });
  };

  const iconStyle = {};
  if (!isArchived) iconStyle["far"] = true;
  else iconStyle["fas"] = true;

  // TODO Warning: Expected `onClick` listener to be a function, instead for `false`.
  return (
    <MoreButton
      onClick={isArchived ? activateSignup : archiveSignup}
      disabled={isLoading}
      forceHover={isLoading}
    >
      <FnrLoadingBricks loading={isLoading} color="#278dc1" size={18}>
        <FnrIcon {...iconStyle} fa-archive />
      </FnrLoadingBricks>
      <MoreButtonText>{isArchived ? "Unarchive" : "Archive"}</MoreButtonText>
    </MoreButton>
  );
}
